import { render } from "./FormCheckbox.vue?vue&type=template&id=7ab48856&ts=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__